<template>
<!-- 관리자 버튼 트리메뉴 컴포넌트 -->
<!-- dropdown을 이용한 트리메뉴 -->
<span class="h-full w-full" v-if="modifiable">
  <el-dropdown trigger="click">
    <el-button size="mini" style="width: 250px; text-align: left;" ref="majorBtn">
      &nbsp;{{btnLabel}}<i class="el-icon-arrow-down" style="position: absolute; left: 226px;"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown" style="width:250px; height: 300px; padding: 5px; overflow-y: auto;">
      <div>
        <div style="background-color: #f5f7fa;">
          <el-input style="height: 40px;padding: 6px 8px;" type="text" v-model="treeFilterText" placeholder="검색해주세요" />
        </div>
        <div style="padding: 0;">
          <el-tree :data="managerList" :props="{ children: 'data', label: 'itemLabel'}" :default-expand-all="true" :highlight-current="true" :filter-node-method="filterNode" @node-click="treeNodeClick" ref="managerTree" />
        </div>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
  <i class="el-icon-delete" style="cursor:pointer;" @click="removeManager()" />
</span>
<span v-else> {{btnLabel}} </span>
</template>

<script>
import has from 'lodash/has';
import Editingf from '@/mixins/editingForm';
import commonAPI from '@/api/config/common';
import { EMPTY_TEXT } from '@/utils/string';

export default {
  name: 'WManagerTreeForm',
  props: ['modifiable', 'objInfo', 'property'],
  mixins: [Editingf],
  data() {
    return {
      treeFilterText: '',
      btnLabel: '',
      managerList: [],
      selMgrId: '',
    };
  },
  watch: {
    modifiable() {
      if (this.modifiable) {
        this.startEdit(this.objInfo, this.property);
      } else {
        this.endEdit(this.selMgrId);
      }
    },
    objInfo() {
      this.loadData();
    },
    treeFilterText(val) {
      // 관리자 트리메뉴 검색창 작성시 감지해서 filter
      this.$refs.managerTree.filter(val);
    },
  },
  // mounted() {
  //   this.loadData();
  // },
  methods: {
    loadData() {
      // 관리자 button tree menu 위한 manager list 로드
      commonAPI.getMgrTreeInfoList({}).then((res) => {
        this.managerList = res.data.data;
        this.changeManagerBtnLabel(this.objInfo);
      });
    },
    changeManagerBtnLabel(objInfo) {
      if (objInfo) {
        if (has(objInfo, this.property)) {
          // objInfo의 관리자 값에 따라 버튼 label 설정
          const me = this;
          const property = this.property;

          this.selMgrId = objInfo[property];

          this.managerList.forEach((association) => {
            association.data.forEach(() => {
              const mgr = me.findMgr(association, objInfo[property]);
              if (mgr) {
                me.setBtnLabel(mgr.itemInfo);
              }
            });
          });
        } else {
          this.btnLabel = EMPTY_TEXT;
        }
      }
    },
    findMgr(element, value) {
      if (element && value) {
        if (element.itemInfo && element.itemInfo.managerId === value) {
          return element;
        } else if (element.data != null) {
          let result = null;
          for (let i = 0; result == null && i < element.data.length; i += 1) {
            result = this.findMgr(element.data[i], value);
          }
          return result;
        }
      }
      return null;
    },
    setBtnLabel(itemInfo) {
      this.btnLabel = `${itemInfo.managerName} `;

      if (itemInfo.associationLabel) {
        this.btnLabel += ` [ ${itemInfo.associationLabel} ]`;
      }

      if (itemInfo.departmentLabel) {
        this.btnLabel = this.btnLabel.slice(0, this.btnLabel.length - 1);
        this.btnLabel += ` - ${itemInfo.departmentLabel} ]`;
      }

      if (itemInfo.mobileNumber) {
        this.btnLabel += ` / ${itemInfo.mobileNumber}`;
      }
    },
    treeNodeClick(data) {
      // 노드 클릭시 관리자 버튼에 텍스트 바인딩
      if (data && data.itemInfo) {
        const itemInfo = data.itemInfo;

        this.$set(this.objInfo, this.property, itemInfo.managerId);

        this.setBtnLabel(itemInfo);

        this.selMgrId = itemInfo.managerId;
        this.updateEdit(this.selMgrId);
      }
    },
    filterNode(value, data) {
      // 관리자 트리메뉴 검색
      if (!value) return true;
      return data.itemLabel.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    removeManager() {
      this.btnLabel = '';
      this.selMgrId = '';
      this.$set(this.objInfo, this.property, '');
      this.updateEdit(this.selMgrId);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/formeditor/MgrTreeSelectEditor.vue